/**
 * 缓存说明:虚拟设备缓存
 */
import vm from '@/cache/storeTools.js'
import eventApi from '@/components/api/eventApi.js'
import recordApi from '@/components/api/money/recordApi.js'
import unitApi from '@/components/api/unitApi.js'
import meterReadingApi from '@/components/api/meterReading/meterReadingApi.js'

var basestate = {
	// 当前公司信息
	nowUnit: {},
	nowUser: {},
	columns: [{
		name: '设备名称',
		key: 'deviceName'
	},{
		name: '设备编号',
		key: 'deviceNo'
	},{
		name: '业主姓名',
		key: 'ownerName',
		type: 'slot'
	},{
		name: '抄表日期',
		key: 'deductionFeeDay',
		// type: 'slot'
	},{
		name: '实时用水量(m³)',
		key: 'realElectricQuantity'
	},{
		name: '实时水费(元)',
		key: 'realAmount',
		// type: 'slot'
	},
		{
			name: '上月用水量(m³)',
			key: 'electricQuantity',
			// type: 'slot'
		}, {
			name: '上月水费(元)',
			key: 'amount',
			// type: 'slot'
		},{
			name: '是否开户',
			key: 'state',
			type: 'slot'
		},{
			name: '联网状态',
			key: 'deviceState',
			type: 'slot'
		},{
			name: '开合闸状态',
			key: 'state232',
			type: 'slot'
		},

		{
			name: '用户累计费用',
			key: 'userBalanceSum',
			// type: 'slot'
		},
		//
		// {
		// 	name: '剩余电量',
		// 	key: 'remainingElectricity',
		// 	type: 'slot'
		// },

		{
			name: '操作',
			key: 'operate',
			type: 'slot'
		}],
	chargingStatusList: [{text:'请选择',value:''},{text:'已缴费',value:0},{text:'欠费',value:-1}],
	deviceStatusList: [{text:'请选择'},{text:'已关联',value:true},{text:'未关联',value:false}],
	deviceInfo: {},
	deviceEvent: {
		data: [],
		total: 0
	},
	devicePayRecords: {
		dataList: [],
		total: 0
	},  // 设备支付记录列表
	allChargeMode: {
		SingleBilling: [],
		StepBilling: [],
		PeakAndValleyBilling: []
	}, // 所有的计费方式
	meterList: [], // 抄表设备列表
	unitDeductionFeeDay: null, // 单位抄表日期
}

var store = new vm.Vuex.Store({
	state: copy(basestate),
	getters: {
		getDeviceInfo(state, getters) {
			if(isempty(state.deviceInfo)){
				return []
			}
			return state.deviceInfo
		},
		getDeviceEvent(state, getters) {
			if(state.deviceEvent.total <= 0){
				return {
					data: [],
					total: 0
				}
			}
			return state.deviceEvent
		},
		getDevicePayRecords(state, getters) {
			if(state.devicePayRecords.total <= 0){
				return {
					dataList: [],
					total: 0
				}
			}
			return state.devicePayRecords
		}
	},
	mutations: {
		clear() {
			//清理缓存
			store.replaceState(copy(basestate))
		},
		setNowUnit(state, unit) {
			if(unit == undefined || isempty(unit)){
				return
			}
			vm.Vue.set(state, 'nowUnit', unit)
			store.commit('getMeterReadingConfigList', unit.id)
			// store.commit('getUnitDeductionFeeDay')
			store.commit('getAllMeterBillingMode', unit.id)
		},
		setNowUser(state, user) {
			if(user == undefined || isempty(user)){
				return
			}
			vm.Vue.set(state, 'nowUser', user)
		},
		setDeviceInfo(state, deviceInfo) {
			vm.Vue.set(state, 'deviceInfo', deviceInfo)
			store.commit('getDeviceEvent', deviceInfo)
			store.commit('getDevicePayRecords', deviceInfo)
		},
		// 获取设备事件信息
		getDeviceEvent(state, deviceInfo) {
			if(isempty(deviceInfo) || deviceInfo == undefined){
				return
			}
			vm.Vue.set(state, 'deviceEvent', {data:[],total:0})
			var today = new Date()
			var year = today.getFullYear()
			var month = today.getMonth()
			var todayTime = today.getTime()
			eventApi.searchEventListByUser(state.nowUser.id, state.nowUnit.id, '', -1, '', deviceInfo.deviceNo, new Date(year, month, 1).getTime(),
				todayTime, 1, 100, '',
				respon => {
					vm.Vue.set(state, 'deviceEvent', respon)
				})
		},
		// 获取设备支付记录列表
		getDevicePayRecords(state, deviceInfo) {
			if(isempty(deviceInfo) || deviceInfo == undefined){
				return
			}
			vm.Vue.set(state, 'devicePayRecords', {dataList:[],total:0})
			recordApi.searchRecordLimit(deviceInfo.deviceNo.toString(), 'MeterReading', 1, 100, undefined, undefined, undefined, respon => {
				vm.Vue.set(state, 'devicePayRecords', respon)
			})
		},
		getAllMeterBillingMode(state, unitId) {
			meterReadingApi.getAllMeterBillingMode(unitId,"second",respon => {
				respon.StepBilling.forEach(item => {
					var stepArr = item.deductionStandard.split(';')
					Object.assign(item, {
						priceOne:stepArr[0].split(':')[1],
						priceTwo:stepArr[1].split(':')[1],
						priceThree:stepArr[2],
						stairNumOne:stepArr[0].split(':')[0],
						stairNumTwo:stepArr[1].split(':')[0]
					})
				})
				vm.Vue.set(state, 'allChargeMode', respon)
			})
		},
		getMeterReadingConfigList(state, unitId){
			meterReadingApi.getMeterReadingConfigListByUnitId(unitId, respon => {
				vm.Vue.set(state, 'meterList', respon)
			})
		},
		// getUnitDeductionFeeDay(state){
		// 	unitApi.getUnitDeductionFeeDay(state.nowUnit.id, respon => {
		// 		vm.Vue.set(state, 'unitDeductionFeeDay', respon)
		// 	})
		// }
	}
});

//对外提供
export default store